var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3239_22276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7188 12.041C23.7188 18.5129 18.4718 23.7598 12 23.7598C5.52811 23.7598 0.28125 18.5129 0.28125 12.041C0.28125 5.56913 5.52811 0.322266 12 0.322266C18.4718 0.322266 23.7188 5.56913 23.7188 12.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0013 12.9832V17.8149H16.2004V13.3075C16.2004 12.1753 15.7965 11.4022 14.7815 11.4022C14.0084 11.4022 13.5483 11.9234 13.3454 12.4273C13.2709 12.6068 13.2525 12.8567 13.2525 13.1097V17.8149H10.4506C10.4506 17.8149 10.4884 10.1802 10.4506 9.38988H13.2525V10.5842C13.2475 10.5934 13.2393 10.6024 13.2342 10.6116H13.2525V10.5842C13.6249 10.011 14.2889 9.19188 15.777 9.19188C17.6202 9.19188 19.0013 10.3965 19.0013 12.9832ZM7.52124 5.3291C6.56241 5.3291 5.93616 5.95845 5.93616 6.78466C5.93616 7.59349 6.54408 8.24009 7.48453 8.24009H7.50188C8.47903 8.24009 9.08695 7.59354 9.08695 6.78466C9.06858 5.95849 8.47903 5.3291 7.52124 5.3291ZM6.10242 17.8149H8.90231V9.38988H6.10242V17.8149Z",
    fill: "#191919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3239_22276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ee8a13f963b9e0f043fba9fe29246f0c.svg";
export { ForwardRef as ReactComponent };